import { Tag } from "antd";
import { CSSProperties, ReactNode } from "react";

const SelectTag = ({
  color,
  label,
  styles,
}: {
  color?: string;
  label: string | ReactNode;
  styles?: CSSProperties;
}) => {
  return (
    <Tag
      bordered={false}
      color={color}
      style={{
        textTransform: "uppercase",
        fontSize: 7,
        fontWeight: 400,
        letterSpacing: 1.1,
        padding: "2px 3px",
        lineHeight: 1,
        ...styles,
      }}
    >
      {label}
    </Tag>
  );
};

export default SelectTag;
